import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import {
  STORE_CLASS_DIAGNOSTIC_REQUEST,
  LIST_CLASS_DIAGNOSTICS_REQUEST,
  GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST,
  DELETE_CLASS_DIAGNOSTIC_REQUEST,
} from '../actions';
import {
  storeClassDiagnosticSuccess,
  storeClassDiagnosticError,
  listClassDiagnosticsSuccess,
  listClassDiagnosticsError,
  getClassDiagnosticDetailSuccess,
  getClassDiagnosticDetailError,
  deleteClassDiagnosticSuccess,
  deleteClassDiagnosticError,
} from './actions';

const storeClassDiagnosticAsync = async (data) =>
  api
    .post('class-diagnostics', data)
    .then((r) => r)
    .catch((e) => e);

function* storeClassDiagnostic({ payload }) {
  try {
    const res = yield call(storeClassDiagnosticAsync, payload);
    if (!res.response) {
      yield put(storeClassDiagnosticSuccess(res.data.data));
    } else {
      yield put(storeClassDiagnosticError(res.response.data));
    }
  } catch (error) {
    yield put(storeClassDiagnosticError(error));
  }
}

function* listClassDiagnostics({ payload }) {
  try {
    const response = yield call(
      api.get,
      `class-diagnostics/classes/${payload.classId}`
    );
    yield put(listClassDiagnosticsSuccess(response.data.data));
  } catch (error) {
    yield put(listClassDiagnosticsError(error));
  }
}

function* getClassDiagnosticDetail({ payload }) {
  try {
    const { classId, diagnosticId, cycleIs } = payload;
    const response = yield call(
      api.get,
      `class-diagnostics/classes/${classId}/diagnostics/${diagnosticId}/cycles/${cycleIs}`
    );
    yield put(getClassDiagnosticDetailSuccess(response.data.data));
  } catch (error) {
    yield put(getClassDiagnosticDetailError(error));
  }
}

const deleteClassDiagnosticAsync = async (id) =>
  api
    .delete(`class-diagnostics/${id}`)
    .then((r) => r)
    .catch((e) => e);

function* deleteClassDiagnostic({ payload }) {
  try {
    const res = yield call(deleteClassDiagnosticAsync, payload.id);
    if (!res.response) {
      yield put(deleteClassDiagnosticSuccess(payload.id));
    } else {
      yield put(deleteClassDiagnosticError(res.response.data));
    }
  } catch (error) {
    yield put(deleteClassDiagnosticError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(STORE_CLASS_DIAGNOSTIC_REQUEST, storeClassDiagnostic),
    takeLatest(LIST_CLASS_DIAGNOSTICS_REQUEST, listClassDiagnostics),
    takeLatest(GET_CLASS_DIAGNOSTIC_DETAIL_REQUEST, getClassDiagnosticDetail),
    takeLatest(DELETE_CLASS_DIAGNOSTIC_REQUEST, deleteClassDiagnostic),
  ]);
}
